import type { ReactNode } from "react";

import { VStack } from "@chakra-ui/react";

import { Header } from "@shared/ui/molecules/header/header";

type Props = {
  actionSlot?: ReactNode;
  children: ReactNode;
  subTitle?: ReactNode;
  title?: ReactNode;
  onBack?: () => void;
};

export const SubPageTemplate = ({
  actionSlot,
  children,
  subTitle,
  title,
  onBack,
}: Props) => {
  return (
    <VStack alignItems="stretch" gap="4">
      <Header
        actionSlot={actionSlot}
        subTitle={subTitle}
        title={title}
        onBack={onBack}
      />
      {children}
    </VStack>
  );
};
